export default __webpack_public_path__ + "static/media/screen_dropbox_3_2.f085761a.png";